import AlertsContainer from "../../container/admin/alerts";

const Alerts = () => {
    return <AlertsContainer />;
};

export default Alerts;
